// Structs GasRouter's bounded free meter, separate from the native staking route.
export const STRUCTS_FREE_GAS = '20000000';

export const FEE = {
  amount: [
    {
      denom: "ualpha",
      amount: "0",
    },
  ],
  gas: "500000",
};
